var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5a1 1 0 00-1 1v7H6a1 1 0 100 2h7v7a1 1 0 102 0v-7h7a1 1 0 100-2h-7V6a1 1 0 00-1-1z",
    fill: "#2C2D2E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDVDMTMuNDQ3NyA1IDEzIDUuNDQ3NzIgMTMgNlYxM0g2QzUuNDQ3NzIgMTMgNSAxMy40NDc3IDUgMTRDNSAxNC41NTIzIDUuNDQ3NzIgMTUgNiAxNUgxM1YyMkMxMyAyMi41NTIzIDEzLjQ0NzcgMjMgMTQgMjNDMTQuNTUyMyAyMyAxNSAyMi41NTIzIDE1IDIyVjE1SDIyQzIyLjU1MjMgMTUgMjMgMTQuNTUyMyAyMyAxNEMyMyAxMy40NDc3IDIyLjU1MjMgMTMgMjIgMTNIMTVWNkMxNSA1LjQ0NzcyIDE0LjU1MjMgNSAxNCA1WiIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgAdd as ReactComponent };